import { APP_TITLE_DASHBOARD } from '@/constants/verbiages';
import { Dashboard } from '@/features/dashboard';

const DashboardRoute = () => (
  <>
    <title>{APP_TITLE_DASHBOARD}</title>
    <meta
      name="description"
      content="Access the AXPX Web App dashboard to choose modules, start new audits, and review assessments already in progress or completed."
    />
    <Dashboard />
  </>
);

export { DashboardRoute as Dashboard };
